import { usePathname } from 'next/navigation';
import { IEnrichedFlight } from '../../../shared/flight/domain/models/IEnrichedFlight';
import { FlightListScope } from '../../../overview/domain/constants/FlightListScope';
import { getCurrentAirportCodeFromSlug } from '../../../../../components/common/navigation/utils/getCurrentAirportCode';

export function useFlightDetailUrl(
	flight: IEnrichedFlight,
	scope: FlightListScope,
) {
	const {
		scheduledDate,
		codeShareFlightNumber,
		viaAirport,
		arrivalAirport,
		departureAirport,
		arrival,
	} = flight;

	const path = usePathname();
	const airportCode = getCurrentAirportCodeFromSlug(path);
	const pathname = `/${airportCode}/flights/${
		scope === FlightListScope.Arrivals ? 'arrival' : 'departure'
	}`;

	return {
		pathname,
		query: {
			scheduledDate,
			codeShareFlightNumber,
			viaAirport,
			arrivalAirport,
			departureAirport,
			arrival,
		},
	};
}
